import { RequestConfig } from '~/common/services/requests';
import {
  PlatformRequestOptions,
  RequestsApi,
} from '../../../../contexts/RequestsContext';

export const constructGetRequest = async <ResponseType>(
  performRequest: RequestsApi['platformRequest'],
  getPath: string,
  config?: RequestConfig,
  options?: PlatformRequestOptions,
): Promise<ResponseType | undefined> =>
  performRequest<ResponseType>(
    { method: 'GET', url: getPath, ...config },
    options,
  );
